import { Button, Form, Input, Drawer, Card, Modal, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useRef } from "react";
import $axios from "../../services/axios";
import _ from "lodash";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import polyline from "@mapbox/polyline";
import {
  faArrowLeft,
  faPeopleArrows,
  faPhone,
  faUser,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import goongjs from "@goongmaps/goong-js";
import "@goongmaps/goong-js/dist/goong-js.css";
import { listVehicle } from "../../helpers/const";
import moment from "moment";

const Map = ({
  setStep,
  setLoading,
  loading,
  dataServices,
  dataPlace,
  setDataServices,
}) => {
  const history = useHistory();
  const [openNote, setOpenNote] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const [isModalBookingfor, setIsModalBookingfor] = useState(false);
  const [form] = Form.useForm();
  const mapRef = useRef(null); // Thêm useRef để lưu trữ instance của map
  const markersRef = useRef([]);
  const dataLegRef = useRef(null);
  const [addPrice, setAddPrice] = useState(0);
  const [vehicleChoose, setVehicleChoose] = useState(dataServices?.services[0]);
  const [vehicles, setVehicles] = useState(dataServices?.services);
  const [bookForUser, setBookForUser] = useState(false);
  const [userBookingFor, setUserBookingFor] = useState(null);
  const [noteTxt, setNoteTxt] = useState("");
  const [vouchers, setVouchers] = useState([]);

  useEffect(() => {
    setLoading(true);
    getAddPrice();
    if (typeof window !== "undefined") {
      // Phòng trường hợp SSR
      const initMap = (coords) => {
        goongjs.accessToken = "6twIVlSlDTMzUHQNmIwhtQ3Kse88gqZN3JwnHhbN";
        const defaultCoords = [105.854444, 21.029449]; // Tọa
        mapRef.current = new goongjs.Map({
          container: "map",
          center: coords ? [coords.longitude, coords.latitude] : defaultCoords,
          zoom: 15,
          style: "https://tiles.goong.io/assets/goong_map_web.json",
          attributionControl: false,
        });

        mapRef.current.on("load", () => {
          // Gọi hàm calculateAndDisplayRoute sau khi map đã load
          calculateAndDisplayRoute();
          setLoading(false);
        });
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            initMap(position.coords);
          },
          (err) => {
            console.error("Lỗi khi lấy vị trí: ", err);
            initMap(); // Fallback location
          }
        );
      } else {
        initMap(); // Fallback location
      }
    }
  }, []);

  useEffect(() => {
    if (dataServices.services.length > 0) {
      setVehicleChoose(dataServices.services[0]);
    }
  }, [dataServices]);

  const handleBooking = async () => {
    try {
      setLoading(true);
      if (!dataPlace.from || !dataPlace.to || !dataLegRef.current) return;
      const body = {
        ServiceId: vehicleChoose?.id.toString() || "0",
        ServiceName: vehicleChoose?.name || "",
        Note: noteTxt,
        Distance: dataLegRef.current.distance,
        Duration: dataLegRef.current.duration,
        Surge: 1,
        StartPointName: dataPlace.from.placeName,
        StartPointGeocode: dataPlace.from.description,
        StartPointX: dataPlace.from.lat.toString(),
        StartPointY: dataPlace.from.lng.toString(),
        EndPointName: dataPlace.to.placeName,
        EndPointGeocode: dataPlace.to.description,
        EndPointX: dataPlace.to.lat.toString(),
        EndPointY: dataPlace.to.lng.toString(),
        VoucherCode: voucherCode || "",
        Amount:
          (
            Number(vehicleChoose?.fee || 0 + addPrice) -
            Number(voucherValue || 0)
          ).toString() || "0",
        AmountOriginal: vehicleChoose?.fee.toString() || "0",
        AmountDiscount: voucherValue.toString() || "0",
        VatFullName: "",
        VatMst: "",
        VatCompany: "",
        VatEmail: "",
      };
      const resPayment = await $axios.$post(
        "/api/v1/gsm/payment/paymentRequired",
        body
      );
      if (resPayment.data.data.orderId) {
        localStorage.setItem(
          "taxiIpassOrderCode",
          resPayment.data.data.orderId
        );
        setLoading(true);
        try {
          await $axios.$post(`/api/v1/gsm/payment/paymentBankInit`, {
            TransactionId: resPayment.data.data.orderId,
          });
          if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.NativeJavascriptInterface
          ) {
            // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
            window.webkit.messageHandlers.NativeJavascriptInterface.postMessage(
              {
                orderCode: resPayment.data.data.orderId,
              }
            );
          } else {
            console.error(
              "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
            );
          }
        } catch (error) {
          message.error(error.response.data.message);
        } finally {
          setLoading(false);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getVouchers = async () => {
    try {
      const res = await $axios.$post("/api/v1/gsm/payment/getVoucherByOrder", {
        Quantity: 1,
        Total: vehicleChoose.fee,
      });
      const now = moment();
      const validVouchers = res.data.data.filter((voucher) => {
        const start = moment(voucher.startDate);
        const end = moment(voucher.endDate);
        return now.isBetween(start, end, null, "[]"); // [] để bao gồm cả thời gian bắt đầu và kết thúc
      });
      setVouchers(validVouchers);
    } catch (error) {
    } finally {
    }
  };

  const getServicesEstimates = async () => {
    try {
      const res = await $axios.$post("/api/v1/gsm/services/estimates", {
        Distance: dataLegRef.current.distance,
        Duration: dataLegRef.current.duration,
        RegionId: dataServices.regionId,
        Waypoints: dataLegRef.current.waypoints,
      });
      if (res) {
        const services = _.cloneDeep(dataServices.services);
        for (let index = 0; index < services.length; index++) {
          const item = services[index];
          const checkExits = res.data.data.prices.find(
            (itemFind) => itemFind.serviceId === item.id
          );
          if (checkExits) {
            services[index].fee = checkExits.totalPrice;
          }
        }
        setVehicles(services);
        setVehicleChoose(services[0]);
        setDataServices({ ...dataServices, services });
      }
    } catch (error) {
      message.error(
        error.response.data.message || "Không tìm thấy dữ liệu chuyến đi!"
      );
      setStep("booking");
    } finally {
      getVouchers();
    }
  };

  const createCustomMarker = (iconUrl, size) => {
    const el = document.createElement("div");
    el.className = "custom-marker";
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.backgroundSize = "cover";
    return el;
  };

  const createMarker = (latlng, icon, content, title, size = 20) => {
    // Thêm một marker với icon tùy chỉnh
    // @ts-ignore
    const marker = new goongjs.Marker({
      element: createCustomMarker(icon, size),
    })
      .setLngLat([latlng.lng, latlng.lat]) // Tọa độ (Kinh độ, Vĩ độ)
      .addTo(mapRef.current);

    // @ts-ignore
    const popup = new goongjs.Popup({ offset: 25 }).setHTML(content);

    marker.setPopup(popup);
    popup.addTo(mapRef.current);
    markersRef.current.push(marker);
  };

  const calculateAndDisplayRoute = async () => {
    const request = {
      origin: { lat: dataPlace.from?.lat, lng: dataPlace.from?.lng },
      destination: { lat: dataPlace.to?.lat, lng: dataPlace.to?.lng },
    };

    mapRef.current?.setCenter(request.origin);

    let layers = mapRef.current?.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    let firstSymbolId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol") {
        firstSymbolId = layers[i].id;
        break;
      }
    }

    const res = await $axios.$get(
      `https://rsapi.goong.io/Direction?origin=${request.origin.lat},${request.origin.lng}&destination=${request.destination.lat},${request.destination.lng}&vehicle=car&api_key=${process.env.REACT_APP_GOOGNG_API_KEY}`
    );

    if (res.data.routes && res.data.routes.length > 0) {
      const route = res.data.routes[0];

      const geometry_string = route.overview_polyline.points;
      // @ts-ignore
      const geoJSON = polyline.toGeoJSON(geometry_string);
      mapRef.current?.addSource("route", {
        type: "geojson",
        data: geoJSON,
      });
      // Add route layer below symbol layers
      mapRef.current.addLayer(
        {
          id: "route",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#1e88e5",
            "line-width": 5,
          },
        },
        firstSymbolId
      );

      const leg = res.data.routes[0].legs[0];
      dataLegRef.current = {
        distance: leg.distance.value / 1000,
        duration: leg.duration.value / 60,
        waypoints: [
          {
            X: leg.start_location.lat,
            Y: leg.start_location.lng,
          },
          {
            X: leg.end_location.lat,
            Y: leg.end_location.lng,
          },
        ],
      };
      createMarker(
        leg.start_location,
        "/images/person-wave-hand.png",
        `
              <div style="display: flex;padding: 4px;">
                <p style="font-size: 12px; padding-right: 8px; border-right: 1px solid #000;">${leg.duration.text}</p>
                <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;margin-left: 8px;">${leg.start_address}</p>
              </div>
            `,
        leg.start_address
      );

      createMarker(
        leg.end_location,
        "/images/svg/flag-icon.svg",
        `
              <div style="display: flex;padding: 4px 2px;">
                <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${leg.end_address}</p>
              </div>
            `,
        leg.end_address,
        50
      );
      await getServicesEstimates();
    }
  };

  const getAddPrice = async () => {
    try {
      const res = await $axios.$get(`/api/v1/gsm/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        const amount = _.get(res, "data.data.data.amount", 0);
        setAddPrice(amount);
        return amount;
      }
    } catch (error) {
    } finally {
    }
  };

  const focusCurrentLocation = () => {
    const origin = {
      lat: dataPlace.from?.lat,
      lng: dataPlace.from?.lng,
    };
    mapRef.current.setCenter(origin);
    mapRef.current.setZoom(15);
  };

  const applyVoucher = async (e) => {
    if (e) {
      setLoading(true);
      try {
        const res = await $axios.$get(
          `/api/v1/gsm/payment/getVoucher?voucherCode=${e}`
        );
        if (res.data.data.status === 1) {
          setVoucherValue(_.toNumber(res.data.data.amount));
          setVoucherCode(e);
          setVoucherTxt(
            `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
        ${res.data.data.amount.toLocaleString("vi-VN")} đ</span></div>`
          );
          message.success("Áp dụng mã giảm giá thành công!");
          setOpenVoucher(false);
        } else {
          setVoucherTxt(
            `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
          );
          setVoucherValue(0);
          setVoucherCode("");
        }
      } catch (error) {
        setVoucherTxt(
          `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
        );
        setVoucherValue(0);
        setVoucherCode("");
      } finally {
        setLoading(false);
      }
    } else {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
      );
      setVoucherValue(0);
      setVoucherCode("");
    }
  };

  const applyVoucherPick = async (voucher) => {
    let amount = voucher.amountVoucher;
    if (voucher.discountType === "PERCENTAGE") {
      const amountDiscount = Math.ceil(
        (vehicleChoose?.fee || 0 + addPrice) * (voucher.discountValue / 100)
      );
      amount =
        amountDiscount < voucher.maxDiscountValue
          ? amountDiscount
          : voucher.maxDiscountValue;
    }
    setVoucherValue(_.toNumber(amount));
    setVoucherCode(voucher.code);
    setVoucherTxt(
      `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
  ${amount.toLocaleString("vi-VN")} đ</span></div>`
    );
    message.success("Áp dụng mã giảm giá thành công!");
    setOpenVoucher(false);
  };

  const handleFinish = async (values) => {
    setUserBookingFor({
      phone: values.phone,
      fullName: values.fullName,
    });
    setBookForUser(true);
    setIsModalBookingfor(false);
  };

  return (
    <div className="relative flex flex-col h-[100vh] bg-white">
      <div id="map" className="flex-1 max-h-[100%]"></div>
      {/* <div class="marker-center">
      <img src="/images/mark.svg" alt="icon" class="w-4" />
    </div> */}
      <div className="flex flex-col bg-white relative py-4">
        <div className="flex justify-between absolute top-[-40px] w-full px-4">
          <div className="flex gap-3">
            <Button color="primary" variant="outlined">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-primary"
                onClick={() => setStep("booking")}
              />
            </Button>

            <Button
              color="primary"
              variant="outlined"
              onClick={() => setIsModalBookingfor(true)}
            >
              <FontAwesomeIcon icon={faPeopleArrows} className="text-primary" />
              <span className="font-semibold">
                {bookForUser ? userBookingFor.fullName : "Đặt hộ"}
              </span>
              {bookForUser && (
                <FontAwesomeIcon
                  icon={faClose}
                  className="text-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    form.resetFields();
                    setBookForUser(false);
                    setUserBookingFor(null);
                  }}
                />
              )}
            </Button>
          </div>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => focusCurrentLocation()}
          >
            <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
              <defs></defs>
              <g
                id="Home-2"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="1-Home" transform="translate(-259.000000, -279.000000)">
                  <g
                    id="ic_current"
                    transform="translate(259.000000, 279.000000)"
                  >
                    <circle
                      id="Oval"
                      stroke="currentColor"
                      stroke-width="2"
                      fill="#FFFFFF"
                      cx="8.5"
                      cy="8.5"
                      r="7.5"
                    ></circle>
                    <circle
                      id="Oval"
                      fill="currentColor"
                      cx="8.5"
                      cy="8.5"
                      r="4.25"
                    ></circle>
                  </g>
                </g>
              </g>
            </svg>
          </Button>
        </div>
        <div className="flex flex-col gap-4 px-4">
          {vehicles.length > 0 &&
            vehicleChoose &&
            vehicles?.map((vehicle) => (
              <div
                key={vehicle.id}
                onClick={() => setVehicleChoose(vehicle)}
                className={`items-center ${
                  vehicleChoose.id === vehicle.id
                    ? "border border-primary border-solid"
                    : "bg-[#f3f4f6]"
                } flex p-4 justify-between rounded-xl`}
              >
                <div className="flex gap-4 items-center justify-center">
                  <img src={vehicle?.imgMain} alt="" className="w-[64px]" />
                  <div className="flex flex-col gap-2">
                    <div className="text-[14px] font-semibold">
                      {vehicle?.name.replace("Emddi Fixed", "IpassGo")}
                    </div>
                    <div className="text-[12px] font-semibold">
                      {listVehicle[vehicle?.vehicleType]?.seatCount} chỗ
                    </div>
                  </div>
                </div>
                {vehicle?.fee && (
                  <div className="flex flex-col gap-2">
                    <div
                      className={`text-[16px] font-semibold ${
                        voucherValue > 0 ? "line-through !text-[14px]" : ""
                      }`}
                    >
                      {(vehicle?.fee || 0 + addPrice).toLocaleString("vi-VN")} đ
                    </div>
                    {voucherValue > 0 && (
                      <div className="text-[16px] font-semibold text-green-500">
                        {(
                          (vehicle?.fee || 0 + addPrice) - voucherValue
                        ).toLocaleString("vi-VN")}{" "}
                        đ
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
        </div>
        <div className="px-4 mt-4">
          <div className="flex justify-between">
            <div
              className="w-1/2 text-center text-sm font-semibold"
              onClick={() => setOpenVoucher(true)}
            >
              Khuyến mãi
            </div>
            <div
              className="w-1/2 text-center text-sm font-semibold"
              onClick={() => setOpenNote(true)}
            >
              Ghi chú
            </div>
          </div>
          <Button
            className=" w-full mt-4"
            size="large"
            variant="solid"
            color="primary"
            onClick={() => handleBooking()}
          >
            <span className="text-[16px] font-bold text-white">Đặt Xe</span>
          </Button>
        </div>
      </div>

      <Drawer
        title={
          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <span className="uppercase font-bold tex-[20px]"> Ghi chú</span>
              <CloseOutlined
                onClick={() => setOpenNote(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
          </div>
        }
        footer={
          <Button
            variant="solid"
            color="primary"
            size="large"
            className="w-full"
            onClick={() => {
              setOpenNote(false);
            }}
          >
            <span className="text-[16px] font-semibold "> Lưu</span>
          </Button>
        }
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenNote(false)}
        open={openNote}
        height={"100%"}
      >
        <Card variant="borderless" className="w-full">
          <div className="text-[16px] font-semibold mb-4">
            Ghi chú cho tài xế
          </div>
          <Input.TextArea
            rows={4}
            placeholder="Nhập ghi chú"
            value={noteTxt}
            onChange={(e) => setNoteTxt(e.target.value)}
            allowClear
          />
        </Card>
      </Drawer>

      <Drawer
        title={
          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <span className="uppercase font-bold tex-[20px]">
                {" "}
                Mã giảm giá của tôi
              </span>
              <CloseOutlined
                onClick={() => setOpenVoucher(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
            {/* <div>
              <Input.Search
                placeholder="Bạn có mã giảm giá khác"
                enterButton={<Button type="primary">Áp dụng</Button>}
                allowClear
                onChange={(e) => {
                  if (!e.target.value) {
                    setVoucherTxt("");
                    setVoucherValue(0);
                  }
                }}
                onSearch={applyVoucher}
              />
              {voucherTxt && (
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
            </div> */}
          </div>
        }
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenVoucher(false)}
        open={openVoucher}
        height={"100%"}
      >
        {vouchers.map((voucher) => (
          <div
            style={{
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" rounded-[14px] bg-white p-2 mb-4"
          >
            <div className="flex gap-2 w-full items-center justify-between">
              <img src="/images/logo-taxi.jpg" className="w-[60px]" alt="" />
              <div className="flex flex-col">
                <div className="font-semibold text-[16px] text-primary">
                  {" "}
                  Mã {voucher.code}
                </div>
                <div className="text-red-600 text-[14px] font-bold">
                  {voucher.title}
                </div>{" "}
                <div className="text-[14px]">
                  Áp dụng từ{" "}
                  {dayjs(voucher.startDate).format("HH:mm DD/MM/YYYY")} đến{" "}
                  {dayjs(voucher.endDate).format("HH:mm DD/MM/YYYY")}
                </div>
                <div
                  onClick={() => applyVoucherPick(voucher)}
                  className="text-blue-700 font-medium text-[14px] ml-auto"
                >
                  <span className="font-semibold">Áp dụng</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Drawer>

      <Modal
        open={isModalBookingfor}
        title={
          <div className="text-primary text-[20px] font-bold">
            Đặt hộ xe người khác
          </div>
        }
        onCancel={() => setIsModalBookingfor(false)}
        footer={null}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        centered={true}
      >
        <Form
          form={form}
          onFinish={handleFinish}
          layout="vertical"
          onFinishFailed={(values) => {}}
          className="w-full"
        >
          <div className="w-full">
            <Form.Item
              name="fullName"
              label="Họ và tên"
              rules={[
                {
                  required: true,
                  message: "Họ và tên không được để trống",
                },
              ]}
              className="mb-3 w-full"
            >
              <Input
                size="large"
                prefix={
                  <FontAwesomeIcon icon={faUser} className="text-primary" />
                }
                placeholder="Họ và tên"
              />
            </Form.Item>
          </div>
          <Form.Item
            name="phone"
            label="Số điện thoại"
            rules={[
              {
                required: true,
                message: "Số điện thoại không được để trống",
              },
              {
                pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                message: "Số điện thoại không hợp lệ",
              },
            ]}
            className="mb-5 w-full"
          >
            <Input
              size="large"
              prefix={
                <FontAwesomeIcon icon={faPhone} className="text-primary" />
              }
              placeholder="Nhập số điện thoại..."
            />
          </Form.Item>
          <div className="flex justify-between gap-4 py-4">
            <Button
              color="danger"
              variant="filled"
              style={{ height: 48 }}
              onClick={() => setIsModalBookingfor(false)}
            >
              <span className="text-[18px] font-bold">Huỷ</span>
            </Button>
            <Button
              htmlType="sumit"
              style={{ height: 48 }}
              className="flex-1"
              type="primary"
              loading={loading}
            >
              <span className="text-[18px] font-semibold text-white">
                Xác nhận đặt xe
              </span>
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Map;
